import { render } from "./Lipud.vue?vue&type=template&id=60a49bd5&scoped=true"
import script from "./Lipud.vue?vue&type=script&lang=js"
export * from "./Lipud.vue?vue&type=script&lang=js"

import "./Lipud.vue?vue&type=style&index=0&id=60a49bd5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60a49bd5"]])

export default __exports__